export const language: any = {
  add_by_image: "Add as photo",
  add_image_by_camera: "Take pictures with a camera",
  add_image_by_gallery: "Select a photo",
  loading: "We are preparing a delicious recipe.\nPlease wait a moment.",
  retry: "Retry",
  cancel: "Cancel",
  yes: "Yes",
  no: "No",
  goToIngredient: "Analyzing Ingredients",
  goToRecipe: "Analyzing Dish",
  recipe: {
    title: "AI Recipe",
    analysis_results: "Analysis results",
    ingredients: {
      title: "Ingredients (1 serving)",
      view_more: 'See more materials',
      view_less: 'Fold',
    },
    how_to_cook: "Cooking method",
    go_to_detail: "View AI recipe",
    description: "Recipe Introduction",
    calories: "Calories",
    time: "Cooking Time",
    ingredient: "Main Ingredients",
    spice: "Seasoning",
    tip: "TIP",
  },
  ingredient: {
    title: "Photo Analysis",
    analysis_results: "The photo analysis result material is as follows.",
    add_to_cart: "Add to Cart",
    add_to_my_ingredients: "Add ingredients",
  },
  msg: {
    not_ingredients: `This is an amazing photo,\nbut this space is all about ingredients!\nNext time, capture some tasty ingredients—\nthe secrets of cooking are waiting for you!\nDo you want to go to AI Chef?`,
    // AC-01-MSG-01
    not_recipes: `Well, it's not cooking!\nWe can only analyze photos of dishes.\nPlease upload a photo of the finished dish.\nWould you like to go to analyze the ingredients?`,
    not_found: "not_found",
    unknow: `I don't think it's a photo of a dish or ingredients.\nPlease upload a photo of your dish\nor ingredients for analysis.\nWe can help you better!`,
    upload_fail: `Upload failed due to a temporary error.\nPlease try again in a moment.`,
    error: `Oh! The photo analysis wasn't good.\nSelect a picture again, or,\nShould we try a clearer picture?`,
    bothType: `The ingredients and dish arein the photo!\nPlease select what you want to analyze in the photo.`
  },
}
